import { Navigate, useSearchParams } from 'react-router-dom';


// Back-compat redirect: the old /compliance/third-parties page has been
// folded into the /compliance/contracts Third Parties tab. External
// bookmarks, sidebar links, and audit-log cross-links (which carry ?id=)
// keep working by forwarding here with their query string preserved.
export default function ThirdPartiesRedirect() {
  const [searchParams] = useSearchParams();
  const next = new URLSearchParams(searchParams);
  next.set('tab', 'third-parties');
  return <Navigate to={`/compliance/contracts?${next.toString()}`} replace />;
}
